import { useCart, useDrawer } from '@/hooks';
import { Button, Icon, Text } from '@holo/ui';
import { useTranslation } from 'next-i18next';

const CartButton = () => {
  const { t } = useTranslation();
  const { open } = useDrawer('cart');
  const { cart } = useCart();

  return (
    <Button
      variant="quartenary"
      onPress={open}
      disabled={!cart?.totalUniqueItems}
      cursor={cart?.totalUniqueItems ? 'pointer' : 'none'}
      opacity={1}
      testID="cart-button"
    >
      <Text color="$contrast" fontWeight="$semi-bold" display="flex" space="$2" alignItems="center">
        <Icon icon="shoppingCart" size={14} />
        {t('cart.title', { count: cart?.totalUniqueItems || 0 })}
      </Text>
    </Button>
  );
};

export default CartButton;
